<app-header></app-header>

<div class="page-title-area item-bg1">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="index.html">Acasa</a></li>
                <li><a routerLink="/specialitati-medicale">Specialitati Medicale</a></li>
                <li>{{specialty.name}}</li>
            </ul>
            <h2>{{specialty.name}}</h2>
        </div>
    </div>
</div>

<div class="courses-details-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <div class="container">
                    <div [innerHTML]="specialty.description"></div>
                </div>
                <div class="courses-details-desc">
                    <div class="courses-review-comments">
                        <h3>Medici</h3>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="user-review" *ngFor="let doctor of specialty.doctors">



                                    <div *ngIf="doctor.photo"><img [src]="setFilePath(doctor)" alt="test"></div>
                                    <div *ngIf="!doctor.photo"><img src="../../../assets/img/medici/no-image.jpg" alt="image"></div>
                                    <div>
                                        <span class="d-block sub-comment">Dr. {{doctor.name}}</span>
                                        <p *ngIf="doctor.medicalStaffType == 'M'">Medic {{doctor.professionalDegree}}</p>
                                        <p *ngIf="doctor.medicalStaffType == 'L'">Biolog (Laborant Sef) </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-lg-4">
                <app-sidebar-specialites></app-sidebar-specialites>

            </div>
        </div>
    </div>
</div>
